/**
 * "Vraagt aandacht", the one use of stripes in the De Ceuster house style:
 * 45° stripes over a mark's own fill, white over the dark fills and ink over
 * the light ones, every `period` px along each axis, `width` px wide. Period
 * 5 and width 1,5 leave two or three stripes on a 9 px strip dot and five on
 * a 14 px square, and keep the fill dominant, so a striped square still reads
 * as its state.
 *
 * The Bezettingsgraad app and the roadmap's month bar both draw them from
 * here, so the mark looks the same wherever it shows.
 */
export const STRIPES = Object.freeze({ period: 5, width: 1.5 });

/**
 * One tile of the stripes, `period` px square, as an SVG path: three
 * segments, so the tiles join into unbroken 45° lines. Stroke it
 * `STRIPES.width` wide with square caps, in a pattern of the same period.
 */
export function stripeTile(period: number = STRIPES.period): string {
  return `M-1 1L1 -1M0 ${period}L${period} 0M${period - 1} ${period + 1}L${period + 1} ${period - 1}`;
}
